import React from "react";
import { Row } from "antd";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useAlreadyCollectModel } from "./alreadyPayModel";
import { useCashPayModel } from "../../cashPayModel";
import { partnerTypeDs, tradeTypeDs } from "@/types/FmsDs";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel, fn } from "@/model/globalModel";

export const AlreadyPaySearchBox = () => {
    const {
        searchParam,
        updateSearchParam,
        onReset,
        onSearch,
        loadData
    } = useAlreadyCollectModel(model => [model.searchParam]);

    const { fetchCustomerList, fetchSupplierList } = useGlobalModel(() => []);

    const {
        orgDs,
        beDs,
    } = useCashPayModel(model => [
        model.orgDs,
        model.beDs,
    ])

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        onChange: (data) => {
            updateSearchParam(data)
        }
    }

    const partnerCodeOptions = () => {
        if (!searchParam.partnerTypeCode) return fn
        if (searchParam.partnerTypeCode === UserTypeEnum.CUSTOMER) return fetchCustomerList
        if (searchParam.partnerTypeCode === UserTypeEnum.SUPPLIER) return fetchSupplierList
    }

    const searchFields: (ISearchProp & ISearchField)[] = [

        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "业务编号",
            fieldName: "tradeCode",
            size: "small",
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "业务实体",
            fieldName: "beCode",
            size: "small",
            options: beDs,
            ...searchProp
        },

        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "从属机构",
            fieldName: "orgCode",
            size: "small",
            treeDs: orgDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "对方类型",
            fieldName: "partnerTypeCode",
            size: "small",
            options: partnerTypeDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.AsyncSelect,
            xxl: 4,
            span: 4,
            placeholder: "对方单位",
            fieldName: "partnerCode",
            size: "small",
            selectfetchList: partnerCodeOptions(),
            ...searchProp
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "对方单位",
        //     fieldName: "partnerCode",
        //     size: "small",
        //     options: partnerCodeOptions(),
        //     ...searchProp
        // },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "业务类型",
            fieldName: "tradeTypeCode",
            size: "small",
            options: tradeTypeDs,
            ...searchProp
        },

        {
            type: SearchTypeEnum.RangePicker,
            placeholder: "起止",
            fieldName: "time",
            xxl: 8,
            span: 8,
            size: "small",
            disabled: false,
            ...searchProp,
            onChange: (data) => {
                let newData = {
                    billTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
                        startTime: data.time[0] + ' 00:00:00',
                        endTime: data.time[1] + ' 23:59:59'
                    } : undefined,
                    ...data
                }
                updateSearchParam(newData)
            }
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "系统分支",
            fieldName: "branch",
            size: "small",
            ...searchProp
        },


    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        triggerSearch
                        handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
